<template>
  <section class="d-flex align-items-center p-2 film">
    <div
      v-if="type === 'film'">
      <van-checkbox
        v-model="checked"
        :disabled="disabled"
        class="px-1"
        @change="changeCheckbox"/>
    </div>
    <div
      class="d-flex align-items-center px-2 flex-grow-1"
      @click="routerLink">
      <div class="film__hd">
        <picture
          v-if="data.purchased"
          class="img-fluid">
          <source
            srcset="@/assets/purchased.webp"
            type="image/webp">
          <source
            srcset="@/assets/purchased.png"
            type="image/png">
          <img
            src="@/assets/purchased.png"
            alt="已购买"
            class="img-fluid">
        </picture>
        <picture
          v-else
          class="img-fluid">
          <source
            srcset="@/assets/not-purchased.webp"
            type="image/webp">
          <source
            srcset="@/assets/not-purchased.png"
            type="image/png">
          <img
            src="@/assets/not-purchased.png"
            alt="未购买"
            class="img-fluid">
        </picture>
      </div>
      <div
        :style="width"
        class="film__bd">
        <p
          class="my-1 text-truncate">检查编号：{{ data.patient_info.image_id }}</p>
        <p
          class="my-1 text-truncate">检查部位：{{ data.patient_info.check_item }}</p>
        <p
          class="my-1 text-truncate">检查时间：{{ data.patient_info.check_time }}</p>
      </div>
    </div>
    <div
      v-if="!doctor"
      class="film__ft">
      <van-icon name="arrow"/>
    </div>
  </section>
</template>

<script>
import bus from '@/libs/bus';

export default {
  name: 'FilmListItem',
  props: {
    data: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: 'film',
    },
    doctor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: false,
    };
  },
  computed: {
    to() {
      let name = 'film-detail';
      if (this.type === 'report') {
        name = 'report-detail';
      }
      return {
        name,
        params: { id: this.data.patient_info.image_id },
        query: { hospitalId: this.data.patient_info.hospital_id_ykb },
      };
    },
    width() {
      let width;
      if (this.doctor === true) {
        width = window.innerWidth - 120;
      } else if (this.type === 'film') {
        width = window.innerWidth - 140;
      } else {
        width = window.innerWidth - 124;
      }
      return {
        'max-width': `${width}px`,
      };
    },
    disabled() {
      // 如果是专家看片,只能选择已购.
      // 如果是影像胶片,只能选择未购.
      if (this.doctor) {
        return !this.data.purchased;
      }
      return this.data.purchased;
    },
  },
  activated() {
  },
  mounted() {
    bus.$on('clear_check', (value) => {
      // 不要清空value对应的checkbox
      if (value === this.data.patient_info.image_id) {
        return;
      }
      this.checked = false;
    });
  },
  methods: {
    changeCheckbox() {
      if (this.checked) {
        this.$emit('checked', this.data);
      } else {
        this.$emit('cancel', this.data);
      }
    },
    routerLink() {
      // console.log(this.$route);
      if (this.$route.name !== 'select-film') {
        this.$router.push(this.to);
      }
    },
  },
};
</script>

<style scoped>
.film {
  background-color: #fff;
  border-bottom: solid 1px #eee;
}

.film__hd {
  width: 63px;
}

.film__bd {
  color: #333;
  margin-left: 10px;
}

.film__ft {
  width: 16px;
  color: #d5d5d5;
}
</style>
